import { useQuery } from '@tanstack/react-query';
import { getIntegrations } from 'Services/integrations';
import { useMemo } from 'react';
import { trackError } from 'Utils/errorMonitoring';

const isValidIntegration = (integration) => integration.status !== 'CREATING';

export default function useIntegrations() {
    const {
        data: integrations = [],
        isLoading,
        isFetching,
    } = useQuery({
        queryKey: ['integrations'],
        queryFn: getIntegrations,
        staleTime: Infinity,
        onError: (error) => trackError(error),
    });

    const validIntegrations = useMemo(() => integrations.filter(isValidIntegration), [integrations]);
    const channelIntegrations = useMemo(
        () => validIntegrations.filter((integration) => integration.service_group === 'channel'),
        [validIntegrations],
    );

    return {
        isLoading,
        integrations,
        validIntegrations,
        channelIntegrations,
        isFetching,
    };
}
